function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import IframeResizer from "iframe-resizer-react";
import { getParsedData } from "./getParsedData";

/* Required Sitecore config:
- flexspot needs "pardot-form" class
- it can have only 1 Element
- the Element has to contain a Link item with iframe data
- this component doesn't include styling, just a standard template to copy
*/

export var WDHFlexspotPardotForm = function WDHFlexspotPardotForm(_ref) {
  var elements = _ref.settings.elements;
  var _getParsedData = getParsedData(elements[0]),
    textItems = _getParsedData.textItems,
    url = _getParsedData.url,
    title = _getParsedData.title,
    foldableForm = _getParsedData.foldableForm,
    buttonAlignLeft = _getParsedData.buttonAlignLeft;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    actualHeight = _useState2[0],
    setActualHeight = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    maxHeight = _useState4[0],
    setMaxHeight = _useState4[1];
  useEffect(function () {
    var formIsOpen = maxHeight !== 0 && maxHeight !== actualHeight;
    if (formIsOpen) {
      setMaxHeight(actualHeight);
    }
  }, [maxHeight, actualHeight]);
  var handleClick = function handleClick(e) {
    e.preventDefault();
    setMaxHeight(function (prevState) {
      return prevState === 0 ? actualHeight : 0;
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, textItems === null || textItems === void 0 ? void 0 : textItems.map(function (_ref2) {
    var uid = _ref2.uid,
      html = _ref2.html;
    return /*#__PURE__*/React.createElement("div", {
      key: uid,
      dangerouslySetInnerHTML: {
        __html: html.html
      },
      className: "element__item__text"
    });
  }), foldableForm && /*#__PURE__*/React.createElement("div", {
    className: "element__item__buttonWrapper ".concat(buttonAlignLeft ? "button-align-left" : "")
  }, /*#__PURE__*/React.createElement("button", {
    className: "element__item__button",
    onClick: handleClick
  }, title)), /*#__PURE__*/React.createElement(IframeResizer, {
    style: {
      width: "1px",
      minWidth: "100%",
      maxHeight: foldableForm ? "".concat(maxHeight, "px") : "unset"
    },
    src: url,
    title: title,
    className: "element__item__iframe",
    checkOrigin: ["https://tally.so", "https://go.pardot.com", "https://info.diatec-diagnostics.de", "https://info.diatec-diagnostics.ch", "https://info.diatec-diagnostics.dk", "https://info.diatec-diagnostics.pl", "https://info.maico-diagnostics.com", "https://info.amplivox.com", "https://info.e3diagnostics.com", "https://getquote.e3diagnostics.com", "https://info.grason-stadler.com", "https://info.guymark.com", "https://info.diatec-diagnostics.co.nz", "https://info.soniceq.com", "https://info.diatec-diagnostics.es", "https://info.diatec-diagnostics.it", "https://info.medrx-diagnostics.com", "https://info.diatec-diagnostics.jp", "https://info.diatec-diagnostics.fr", "https://info.diatec-diagnostics.kr"],
    heightCalculationMethod: "lowestElement",
    onResized: function onResized(_ref3) {
      var height = _ref3.height;
      return setActualHeight(height);
    }
  }));
};